import i18n from '@utils/i18n'

export const transferAccountTypes = {
  0: i18n.t('userstatement61'), // 日内账户
  1: i18n.t('userstatement62') // 融资账户
}

export const auditStatusList = {
  1: i18n.t('my81'), // 待审批
  2: i18n.t('my82'), // 已审批通过
  3: i18n.t('my83') // 审批失败
}

export const auditStatusProxyList = {
  0: i18n.t('public33'), // 未上传
  1: i18n.t('my81'), // 待审批
  2: i18n.t('my82'), // 已审批通过
  3: i18n.t('my83') // 审批失败
}

export const userAuthStatusText = {
  0: i18n.t('public33'), // 未上传
  1: i18n.t('public34'), // 待审核
  2: i18n.t('public35'), // 已认证
  3: i18n.t('public36') // 审核失败
}
